@use "~@dia-stylecomponents/themes/dia/colors" as dia-colors;
@use "~@dia-stylecomponents/header/backend-variables" as header-variables;
@use "~@dia-stylecomponents/footer/backend-variables" as footer-variables;
@use "~@dia-stylecomponents/navigation/variables" as navigation-variables;
@use "~@dia-stylecomponents/mixins/grid/variables" as grid-variables;
@use "~@dia-stylecomponents/mixins" as mixins;
@use "~@dia-stylecomponents/themes/dia/variables";
@use "~@dia-stylecomponents/themes/dia/normalize";
@use "~@dia-stylecomponents/themes/dia/table";
@use "~@dia-stylecomponents/themes/dia/button";
@use "~@dia-stylecomponents/themes/dia-backend/input";
@use "~@dia-stylecomponents/themes/dia/select";
@use "~@dia-stylecomponents/themes/dia-backend/textarea";
@use "~@dia-stylecomponents/themes/dia/dialog";
@use "~@dia-stylecomponents/themes/dia/form";
@use "~@dia-stylecomponents/themes/dia/pagination";
@use "~@dia-stylecomponents/themes/dia/tabs";
@use "~@dia-stylecomponents/themes/dia/tooltip";
@use "~@dia-stylecomponents/themes/dia/grid";
@use "~@dia-stylecomponents/themes/dia/panel";
@use "~@dia-stylecomponents/themes/dia-backend/header";
@use "~@dia-stylecomponents/themes/dia-backend/footer";
@use "~@dia-stylecomponents/themes/dia-backend/navigation";
@use "~@dia-ui/behavior_select";
@use "~@dia-ui/behavior_image-zoom";

@import "~print-js/src/sass";
@import url("https://fonts.dia.support/css?family=Inter:wght@400;700;900&display=swap");

@keyframes fadein {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* dia-label-printing */
:host {
  --dia-pagination-height: 56px;

  display: flex;
  position: absolute;
  width: 100%;
  height: auto;
  max-height: 100vh;
  overflow: auto;
  font-family: var(--dia-font-base);

  [data-reload-button] {
    animation: fadein .5s ease-in 3s;
    opacity: 0;
  }

  stencil-route-switch {
    display: flex;
    flex: 100%;
  }

  stencil-route {
    width: 100%;
  }

  button[data-refresh-button] {
    position: absolute;
    justify-self: center;
    align-self: center;
  }

  dia-grid {
    width: 100%;
    height: 100%;
    overflow: visible;

    dia-grid-row {
      grid-auto-columns: 450px 1fr;

      dia-grid-column {
        &:nth-of-type(1) {
          dia-form {
            form {
              --dia-form-max-width: 440px;

              dia-form-line:last-of-type {
                justify-content: space-between;
              }
            }
          }
        }

        &:nth-of-type(2) {
          display: flex;
          flex-wrap: wrap;
          align-content: flex-start;
          width: 510px;

          dia-panel {
            display: flex;
            flex: 100% 1 1;
            flex-wrap: wrap;
            align-self: flex-start;
            min-width: 100%;
            min-height: 200px;
            max-height: max-content;

            dia-panel-content {
              display: inline-grid;
              position: relative;
              justify-content: left;
              padding: 30px;
              background-color: #f1f1f1;

              &:has([has="ruler"]) {
                &::before {
                  content: "cm mm";
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 30px;
                  height: 30px;
                  padding-top: 5px;
                  background: #fff;
                  font-size: 11px;
                  line-height: 10px;
                  text-align: center;
                  overflow-wrap: anywhere;
                }
              }

              picture[data-labelprint-preview-scale] {
                transform: scale(.67);
                transform-origin: left top;
              }
            }

            dia-panel-footer {
              height: auto;

              dia-form {
                flex-wrap: wrap;
                justify-content: flex-start;

                button {
                  --dia-button-secondary-light-border-color: #{dia-colors.$dia-color-neutral-50};
                  --dia-button-min-height: 36px;
                  --dia-button-height: 36px;
                  --dia-button-min-width: min-content;
                  margin-right: 5px;
                  margin-bottom: 5px;
                  padding-right: 55px;
                  padding-left: 15px;
                  overflow: hidden;
                  white-space: nowrap;

                  &::after {
                    height: 36px;
                    min-height: 36px;
                    pointer-events: none;
                  }

                  i {
                    position: absolute;
                    top: 0;
                    right: -5px;
                    align-items: center;
                    justify-content: center;
                    width: 40px;
                    height: 100%;
                    border-left: 1px solid #{dia-colors.$dia-color-neutral-50};
                    background: #{dia-colors.$dia-color-shade-0};

                    &:hover {
                      background: #{dia-colors.$dia-color-neutral-50};
                    }
                  }

                  &[data-selected] {
                    background-color: var(--dia-label-printing-item-active, #{dia-colors.$dia-color-primary-50});

                    i {
                      background-color: inherit;
                    }
                  }

                  &[data-error] {
                    background-color: var(--dia-label-printing-item-active, #{dia-colors.$dia-color-error-50});

                    i {
                      background-color: inherit;
                    }
                  }
                }
              }
            }
          }

          dia-form {
            align-self: flex-end;

            > dia-form-line {
              justify-content: flex-end;

              &[data-label-print-buttons] {
                position: absolute;
                right: 25px;
                bottom: 40px;
              }

              &[data-label-print-info] {
                position: absolute;
                top: 370px;
                left: 30px;
                justify-content: flex-start;
                width: 200px;
                row-gap: 10px;
              }

              dia-form-control {
                gap: 20px;
              }
            }
          }
        }
      }
    }

    :has(dia-grid-row + dia-grid-row) {
      --dia-grid-nested-template-rows: calc(100% - 56px) 56px;

      dia-grid-row {
        grid-auto-columns: 1fr;

        &:nth-of-type(2) {
          dia-form-control:nth-of-type(2) {
            justify-content: flex-end;
          }
        }
      }
    }
  }

  header,
  dia-grid-content {
    grid-template-columns: 1fr;
    width: 100%;
  }

  dialog {
    --dia-dialog-position: relative;
    --dia-dialog-min-height: 859px;
    --dia-dialog-height: max-content;
    border-top-left-radius: 8px;

    border-top-right-radius: 8px;

    dialog-content {
      --dia-header-height: 80px;
      --dia-backend-header-height: 80px;
      --dia-backend-footer-height: 30px;
      --dia-backend-footer-bottom-bar-height: 30px;
      --dia-breadcrumb-height: 40px;

      position: relative;
      padding: 0;

      dia-loader-overlay {
        @keyframes fadeIn {
          from {
            opacity: 0;
            background-color: rgba(255, 255, 255, 0);
          }

          to {
            opacity: 1;
            background-color: rgba(255, 255, 255, .9);
          }
        }

        position: absolute;
        animation: fadeIn .5s;
      }
    }
  }

  header {
    --dia-grid-container-padding: 25px;

    position: absolute;
    top: 20px;
    left: 0;
    grid-template-rows: 1fr;
    overflow-x: clip;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;

    nav:not([aria-label="Breadcrumb"]) {
      z-index: 2 !important;
      justify-content: right !important;

      li[data-expert] {
        display: inline-flex;
        align-items: center;
        padding-right: 11px;
        border-radius: 25px;
        background: #f1f1f1;
        color: #aaa;

        &:has(input[type=checkbox]:checked) {
          color: #222;
        }

        dia-switch {
          margin-right: 5px;
          margin-left: 10px;
        }

        &:hover {
          box-shadow: none;
        }
      }

      li[data-close] {
        margin-left: 10px;
        padding-right: 0;
        cursor: pointer;

        > a {
          i {
            margin: 0;
            font-size: 22px;
          }
        }
      }
    }

    dia-grid-content {
      white-space: nowrap;

      > * > i {
        margin-left: 5px;
      }
    }
  }

  dia-breadcrumb {
    position: absolute;
    top: 0;
    right: 30px;
    left: 0;
    grid-template-rows: 1fr;
    width: 100%;
    padding-left: 30px;
    overflow: hidden;

    nav {
      > ul {
        > li {
          font-size: 14px;
        }
      }
    }
  }

  footer {
    position: absolute;
    bottom: 0;
    left: 0;
  }

  table {
    tr {
      th:not([data-action]):not(.data-action),
      td:not([data-action]):not(.data-action) {
        display: inline-block;
        align-content: flex-start;
        height: 30px;
        overflow: hidden;
        line-height: 16px;
        text-overflow: ellipsis;
        word-break: break-all;
        white-space: break-spaces;
      }

      th:not([data-action]):not(.data-action) {
        align-content: center;
        line-height: inherit;
        text-align: left;
        white-space: nowrap;
      }

      td[data-id],
      td.data-id,
      td[data-text],
      td.data-text {
        position: relative;

        &::after {
          content: "";
          position: absolute;
          right: 0;
          bottom: 0;
          width: 20%;
          height: 13px;
          background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 50%);
          text-align: right;
        }
      }

      &:nth-child(even) {
        td[data-id],
        td.data-id,
        td[data-text],
        td.data-text {
          &::after {
            background: linear-gradient(to right, rgba(248, 248, 248, 0), rgba(248, 248, 248, 1) 50%);
          }
        }
      }
    }

    .data-checkbox,
    [data-checkbox] {
      width: 40px;
    }

    .data-image,
    [data-image] {
      align-content: center !important;
      justify-content: center !important;
      width: 120px !important;
      height: 100% !important;
      padding: 10px;

      > img {
        width: auto;
        height: inherit;
      }
    }

    .data-id,
    [data-id] {
      width: 200px !important;
      text-align: left !important;
    }

    .data-name,
    [data-name] {
      width: 200px !important;
    }

    .data-text,
    [data-text] {
      width: 250px !important;
      text-align: left !important;
    }

    .data-width,
    [data-width] {
      width: 50px !important;
    }

    .data-height,
    [data-height] {
      width: 50px !important;
    }

    .data-quantity,
    [data-quantity] {
      --dia-input-height: 40px;

      width: 70px !important;
    }

    .data-action,
    [data-action] {
      justify-content: right;
      width: 180px !important;

      button:nth-of-type(1) {
        margin-left: 0 !important;
      }
    }

    th.data-action {
      .datatable-sorter {
        display: none;
      }
    }

    &[data-table-medium] {
      --dia-input-height: 41px;

      dia-form-control {
        background: #{dia-colors.$dia-color-neutral-50};

        > * {
          background: transparent;
        }
      }

      tr {
        td {
          width: auto !important;
        }
      }
    }
  }

  main {
    display: grid;
    grid-template-columns: 1fr;
    justify-content: center;
    width: 100%;
    min-height: calc(837px - var(--dia-backend-header-height, 100px) + 40px);
    padding-top: calc(#{header-variables.$dia-backend-header-height} + #{navigation-variables.$dia-breadcrumb-height} + 30px);
    padding-right: 30px;
    padding-bottom: 30px;
    padding-left: 30px;
  }

  dia-grid {
    &:not(:has(header)) {
      main {
        min-height: calc(768px - var(--dia-backend-header-height, 100px) - 15px);
        padding-top: 30px;
      }
    }
  }

  article {
    @include mixins.grid-content;
    justify-content: stretch;
    width: 100%;
    max-width: none;

    section {
      --dia-grid-nested-template-rows: 100%;

      display: flex;
      height: 100%;

      dia-grid-nested {
        height: 100%;

        dia-grid-row {
          grid-auto-rows: 100%;
        }
      }
    }
  }

  dia-form:has([data-label-print-options]) {
    flex-direction: column;

    dia-form-area[data-label-print-options] {
      margin-bottom: 20px;

      [name="option-horizontal-center"] {
        i {
          transform: rotate(90deg);
        }
      }

      dia-form-control {
        justify-content: flex-end;
      }

      + dia-form-line {
        dia-form-control {
          justify-content: flex-end;
        }
      }
    }
  }

  dia-form-control {
    max-width: max-content;

    &:has(select[name="template-id"]),
    &:has(input[name="label-desc"]) {
      flex: 100%;
      max-width: 100%;
    }

    &:has(select[name="page-format"]) {
      flex: 45%;
      max-width: 45%;
    }

    &:has(input[name="template-desc"]) {
      flex: 55%;
      max-width: 55%;
    }

    &:has(select[name="template-id"]) {
      [role="listbox"] {
        z-index: 11;
        min-width: 100%;
      }
    }
  }

  input {
    &[name="label-desc"] {
      --dia-input-width: 100%;
    }

    &[name="color"] {
      --dia-input-width: 170px;
    }

    &[name="font-size"] {
      --dia-input-width: 170px;
    }
  }

  select {
    &[name="template-id"] {
      --dia-select-width: 100%;
    }

    &[name="source-id"] {
      --dia-select-width: 180px;

      + .cs-select {
        width: 180px;
      }
    }

    &[name="font-type"] {
      --dia-select-width: 250px;

      + .cs-select {
        width: 250px;
      }
    }

    &[name="text-align"] {
      --dia-select-width: 250px;

      + .cs-select {
        width: 250px;
      }
    }
  }

  [data-printlist-submit],
  [data-printlist-form] {
    justify-content: right;
  }

  [data-printing-preview] {
    grid-auto-columns: 440px 1fr !important;

    dia-panel-content {
      img {
        max-width: 100% !important;

        &[data-printing-preview-placeholder] {
          opacity: .3;
        }
      }
    }

    dia-grid-column:first-of-type {
      dia-form-line {
        dia-form-control {
          min-width: 100%;
          max-width: 100%;
        }
      }
    }
  }

  picture {
    display: flex;
    position: relative;
    justify-content: center;

    width: fit-content;
    min-width: 100%;
    max-width: fit-content;
    height: fit-content;
    max-height: fit-content;

    [data-labelprint-preview] {
      width: 100%;
      height: auto;
      box-shadow: 2px 2px 4px -3px rgba(0, 0, 0, .4);
    }

    &::before,
    &::after {
      color: #a1a1a1;
      font-size: 13px;
    }

    &[data-preview-width]::before {
      content: attr(data-preview-width) "mm";
      position: absolute;
      bottom: -20px;
      left: calc(50% - 20px);
    }

    &[data-preview-height]::after {
      content: attr(data-preview-height) "mm";
      position: absolute;
      right: -30px;
      bottom: calc(50% - 10px);
      transform: rotateZ(90deg);
    }
  }

  dia-form-control {
    &:has(input[readonly]) {
      i {
        color: #{dia-colors.$dia-color-neutral-300};
      }

      input[readonly] {
        --dia-font-text-color: #{dia-colors.$dia-color-neutral-300};
        pointer-events: none;

        + label {
          color: #{dia-colors.$dia-color-neutral-300};
        }
      }
    }
  }

  dia-datatable {
    table tr {
      transition: opacity 6s ease 1s;
      opacity: .01;
    }

    &:has(table) {
      table tr {
        opacity: 1;
      }
    }
  }
}

:host([opened]) {
  height: 100vh;
}

dia-ruler {
  position: absolute;
  top: 0;
  left: 0;
}

dia-ruler[data-ruler-type="horizontal"] {
  left: 0;
  width: 100%;
  height: 30px;
}

dia-ruler[data-ruler-type="vertical"] {
  top: 0;
  width: 30px;
  height: 100%;
}


dia-switch input[type=checkbox] {
  visibility: hidden;
  width: 0;
  height: 0;
}

dia-switch label {
  display: block;
  position: relative;
  width: 44px;
  height: 24px;
  border-radius: 100px;
  background: #808080;
  text-indent: -9999px;
  cursor: pointer;
}

dia-switch label::after {
  content: "";
  position: absolute;
  top: 3px;
  left: 3px;
  width: 18px;
  height: 18px;
  transition: .3s;
  border-radius: 90px;
  background: #fff;
}

dia-switch input:checked + label {
  background: var(--dia-color-primary, #32b3ca);
}

dia-switch input:checked + label::after {
  left: calc(100% - 3px);
  transform: translateX(-100%);
}

dia-switch label:active::after {
  width: 44px;
}

select:has(option[disabled][hidden]:not(:checked)):valid+label,
select:has(option[disabled][hidden]:not(:checked)):focus+label,
.ts-wrapper.has-items+label {
  color: var(--dia-color-primary, #32b3ca) !important;
}

input[name][type]:not([type=checkbox]):not([type=radio])[placeholder][placeholder=""]:not(:placeholder-shown)[readonly]+label,
input[name][type]:not([type=checkbox]):not([type=radio])[placeholder][placeholder=""]:not(:placeholder-shown):valid+label,
input[name][type]:not([type=checkbox]):not([type=radio])[placeholder][placeholder=""]:not(:placeholder-shown):focus+label {
  color: var(--dia-color-primary, #32b3ca) !important;
}

nav:not([aria-label=Breadcrumb])>ul[main] li>span>ul>li:hover>a,
nav:not([aria-label=Breadcrumb])>ul[main] li>span>ul>li:active>a {
  color: var(--dia-color-primary, #32b3ca) !important;
}
